<template>
  <content-wrapper>
    <content-header>
      Dashboard
    </content-header>
    <Content>
      <!-- rainbow boxes -->
      <div class="row" v-if="can('superadmin|member')">
        <div class="col-lg-3 col-12">
          
          <!-- small box -->
          <div class="small-box" :style="bgGradient('linear-gradient(90deg, #36d1c4, #2196f3)')">
            <div class="inner d-flex align-items-center text-white">
              <div class="w-100">
                <h3 class="text-left">{{ stats.truck }}</h3>
                  <div v-if="can('superadmin|control_room')" class="font-weight-bold text-left">Trucks Registered <br>(<span>{{ todayData.member_count }}</span> members)</div>
                  <div v-else class="font-weight-bold text-left">Trucks Registered <br> <br> </div>
                <div class="small mt-2 d-flex align-items-center">
                  <!-- <i class="fa fa-arrow-up mr-1"></i>
                  +12% from last month -->
                </div>
              </div>
              <div class="icon">
                <i class="fa fa-truck-moving fa-2x"></i>
              </div>
            </div>
<!--            <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a>-->
          </div>
        </div>
        <!-- ./col -->
        <div class="col-lg-3 col-12">
          <!-- small box -->
          <div class="small-box" :style="bgGradient('linear-gradient(90deg, #f7971e, #ffd200)')">
            <div class="inner d-flex align-items-center text-white">
              <div>
                <h3 class="text-left">{{ stats.permit_open }}</h3>
                <div class="font-weight-bold text-left">Permit Open<br><br></div>
                <div class="small mt-2 d-flex align-items-center">
                  <!-- <i class="fa fa-check-circle mr-1"></i>
                  Active permits -->
                </div>
              </div>
              <div class="icon">
                <i class="ion ion-person-add"></i>
              </div>
            </div>
<!--            <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a>-->
          </div>
        </div>
        <!-- ./col -->
        <div class="col-lg-3 col-12">
          <!-- small box -->
          <div class="small-box" :style="bgGradient('linear-gradient(90deg, #EE4445, #EB4897)')">
            <div class="inner d-flex align-items-center text-white">
              <div class="w-100">
                <h3 class="text-left">{{  stats.permit_used }}</h3>
                <div class="font-weight-bold text-left">Permits Used<br><br></div>
                <div class="small mt-2 d-flex align-items-center">
                  <!-- <i class="fa fa-arrow-up mr-1"></i>
                  +8% from last week -->
                </div>
              </div>
              <div class="icon">
                <i class="ion ion-document-text"></i>
              </div>
            </div>
<!--            <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a>-->
          </div>
        </div>
        <!-- ./col -->
        <div class="col-lg-3 col-12">
          <!-- small box -->
          <div class="small-box" :style="bgGradient('linear-gradient(90deg, #23C560, #10B982)')">
            <div class="inner d-flex align-items-center text-white">
              <div>
                <h3 class="text-left">{{  stats.completed }}<sup style="font-size: 20px">%</sup></h3>
                <div class="font-weight-bold text-left">Permit Completed Rate<br><br></div>
                <div class="small mt-2 d-flex align-items-center">
                  <!-- <i class="fa fa-check-circle mr-1"></i>
                  Above target -->
                </div>
              </div>
              <div class="icon">
                <i class="ion ion-stats-bars"></i>
              </div>
            </div>
            <!--            <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a>-->
          </div>
        </div>
        <!-- ./col -->
      </div>
      
      <!-- white boxes -->
      <div class="row" v-if="can('superadmin|control_room|gate_pass')">
        <div class="col-lg-3 col-6">
          <!-- small box -->
          <div class="small-box">
            <div class="inner">
              <p>Kendaraan Masuk (Hari Ini)</p>
              <h3>{{ todayData.total_in }}</h3>
            </div>
            <div class="icon">
              <!-- <i class="fa fa-truck-moving"></i> -->
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-6">
          <!-- small box -->
          <div class="small-box">
            <div class="inner">
              <p>Kendaraan Keluar (Hari Ini)</p>
              <h3>{{ todayData.total_out }}</h3>
            </div>
            <div class="icon">
              <!-- <i class="fa fa-truck-moving"></i> -->
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-6">
          <!-- small box -->
          <div class="small-box">
            <div class="inner">
              <p>Total Aktifitas (24 Jam)</p>
              <h3>{{ todayData.total_activity }}</h3>
            </div>
            <div class="icon">
              <!-- <i class="fa fa-truck-moving"></i> -->
            </div>
          </div>
        </div>

        <div class="col-lg-3 col-6">
          <!-- small box -->
          <div class="small-box">
            <div class="inner">
              <p>Akses Ditolak (Hari Ini)</p>
              <h3>0</h3>
            </div>
            <div class="icon">
              <!-- <i class="fa fa-truck-moving"></i> -->
            </div>
          </div>
        </div>
      </div>

      <!-- download intensitas truck -->
      <div class="row" v-if="can('superadmin|control_room')">
        <div class="d-flex flex-sm-row flex-column w-100 justify-content-center mx-2 bg-white shadow">

          <div class="mx-2 d-flex align-items-center">
            <b-form-datepicker label-no-date-selected="Start Date" id="date_from" v-model="date_from" class="my-2"></b-form-datepicker>
          </div>

          <div class="mx-2 d-flex align-items-center">
            <b-form-datepicker label-no-date-selected="End Date" id="date_to" v-model="date_to" class="my-2"></b-form-datepicker>
          </div>
          
          <div class="d-flex justify-content-center align-items-center">
            <button
              class="btn btn-sm btn-primary my-2 mx-2"
              :disabled="isLoadingTruckIntensity"
              style="min-width: 180px"
              @click="download_truck_intensity"
            >
              <span v-if="!isLoadingTruckIntensity">
                <b-icon-file-earmark-excel style="font-size:15px; vertical-align: middle;"></b-icon-file-earmark-excel>
                &nbsp;Excel Truck Intensity
              </span>
              <span v-else class="d-flex align-items-center justify-content-center">
                <b-spinner small class="align-middle"></b-spinner>
                <span class="ml-2">Loading...</span>
              </span>
            </button>
          </div>
          
        </div>
      </div>

      <!-- graphic tabs -->
      <div class="row" v-if="can('superadmin|control_room|gate_pass')">
        <div class="col-12">
          <div class="d-flex flex-sm-row flex-column justify-content-center my-3 bg-white shadow">
            <DashboardTabs 
              :barChartData="barChartData" 
              
              :lineChartData="lineChartData"
              :line-loading="lineChartLoading"
              :selected-period="selectedPeriod"
              @period-selected="onPeriodSelected"
              
              :heatMapData="heatMapData"
              @change-heatmap-mark="onChangeHeatmapMark"

              :activityLogData="activityLogData"
              :frequentlyTrucking="frequentlyTrucking"
              :gateOdolData="gateOdolData"
              :auditLogData="auditLogData"
              @audit-log-page="loadAuditLog"

            />
          </div>
        </div>
      </div>

      <!-- apexchart -->
      <div class="row" v-if="isSuperAdmin">
        <div class="col-12">
          <h5 class="mt-3 ml-5 font-weight-bold">Daily Traffic Trend</h5>
          <div class="row justify-content-around align-items-center w-100 mb-3">
            <!-- Bar Chart -->
            <div class="col-lg-7 col-md-12 mb-3" style="overflow-x:auto;">
              <apexchart
                ref="vuechart-example"
                :width="'100%'"
                type="bar"
                :options="bar_options"
                :series="bar_series"
              />
            </div>
            <!-- Donut Chart -->
            <div class="col-lg-5 col-md-12 d-flex flex-column align-items-center" style="overflow-x:auto;">
              <apexchart
                ref="vuechart-donut"
                :width="'100%'"
                height="300"
                type="donut"
                :options="don_options"
                :series="don_series"
              />
              <button class="btn btn-sm btn-primary mt-2 mb-2" @click="download_exp_lists">
                <b-icon-file-earmark-excel />
                <span class="text-nowrap">Excel Expired Lists</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- form registrasi -->
      <div class="row" v-if="isSuperAdmin">
        <section class="col mt-2">
          <b-card class="w-100" no-body header="Quick Actions" header-bg-variant="secondary">
            <b-tabs pills card>
              <b-tab title="Add Member" active>
                <b-card-text>
                  <registration-form @registered="showPassword"></registration-form>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-card>
        </section>
      </div>
    </Content>
    
    <!-- Credential Modal -->
    <b-modal v-if="isSuperAdmin" centered header-bg-variant="success" id="credential" size="sm" title="Keep this password"
             ok-only
             no-close-on-esc
             hide-header-close
             no-close-on-backdrop>
      <h4>Please save this Password</h4>
      <h1 class="text-center">{{ password }}</h1>
      <template #modal-footer="{ cancel }">
        <b-button variant="primary" @click="password=null;cancel();">
          OK!
        </b-button>
      </template>
    </b-modal>
  </content-wrapper>
</template>

<script>
import {userInfoMixin} from "@/mixins/userInfoMixin";
import {getDashStats} from "@/services/members";
import {BTab, BTabs} from "bootstrap-vue";
import RegistrationForm from "@/views/Members/RegistrationForm";
import {
  todayInOut,memberCount,
  monthlyOverview, dailyActivity, weeklyHeatmap, activityLogs,
  getExpiredInfo, getInOutInfo, downloadExpLists, downloadTruckIntensity
} from "@/services/persero_btm";
import { getFrequentlyTrucking } from "@/services/persero_btm";
import { getInOutGateOdolInfo, auditLog } from "@/services/mware";
import {BFormDatepicker} from 'bootstrap-vue';
import DashboardTabs from "@/components/DashboardTabs";
export default {
  name: "Dashboard",
  components: { 
    BTab, BTabs,
    RegistrationForm,
    BFormDatepicker,
    DashboardTabs
  },
  mixins: [
      userInfoMixin,
  ],
  data: () => ({
    // explicit loading flag for the line chart
    lineChartLoading: true,
    isLoadingTruckIntensity: false,
    todayData:{
      total_in: 0,
      total_out: 0,
      total_activity: 0,
      member_count: 0
    },
    memberCount:{
      truck_registered: 0,
      active_users: 0,
      permit_open: 0,
      permit_used: 0,
      permit_completion_rate:0
    },
    heatMapData: {
      periods:{
        start:'',
        end:''
      },
      data:[]
    },
    barChartData: {
      labels: [],
      datasets: [
        {
          label: '',
          backgroundColor: '',
          data: []
        },
        {
          label: '',
          backgroundColor: '',
          data: []
        }
      ]
    },
    lineChartData: {
      labels: [],
      datasets: [
        {
          label: '',
          borderColor: '',
          fill: false,
          pointBackgroundColor: '',
          data: []
        },
        {
          label: '',
          borderColor: '',
          fill: false,
          pointBackgroundColor: '',
          data: []
        },
        {
          label: '',
          borderColor: '',
          borderDash: [5, 5],
          fill: false,
          pointRadius: 0,
          pointHitRadius: 0,
          data: []
        }
      ]
    },
    activityLogData:{
      logs: []
    },
    frequentlyTrucking: {
      trucking: []
    },
    gateOdolData:{
      in: {
        total: 0,
        categories: {
          umum: 0,
          container: 0,
          looseCargo: 0,
        },
      },
      out: {
        total: 0,
        categories: {
          umum: 0,
          container: 0,
          looseCargo: 0,
        },
      },
      top10: {
        in: [],
        out: [],
      },
    },
    auditLogData:{
      logs: []
    },
    date_from:"",
    date_to:"",
    selectedPeriod: 6,
    display: 400,
    bar_options: {
      plotOptions: {
          bar: {
          horizontal: false,
          columnWidth: '75%',
          borderRadius: 8, // biar rounded
          endingShape: 'rounded', // biar lebih soft
        }
      },
      chart: {
        id: 'vuechart-example',
        width: '100%',
        type: 'bar',
        toolbar: { show: true },
        fontFamily: 'Inter, "Segoe UI", Arial, sans-serif',
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: '11px',
          colors: ["#fff", "#fff"]
        },
        dropShadow: {
          enabled: false,
        },
        background: {
          enabled: true,
          foreColor: '#333',
          borderRadius: 6,
          padding: 2,
          opacity: 0.7,
        },
        formatter: function(val, { seriesIndex }) {
          if (seriesIndex === 0) { // IN
            return `${val}`;
          } else { // OUT
            return `${val}`;
          }
        },
        useHTML: true,
      },
      colors: ['#29B6F6', '#66E8B3'], // biru muda & hijau muda
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        offsetY: 0,
        offsetX: 0, // geser ke kiri dari toolbar
        fontSize: '14px',
        markers: { radius: 6 },
        labels: { colors: "#99aabb" },
      },
      grid: {
        borderColor: "#e7eaf3",
        strokeDashArray: 4,
        xaxis: { lines: { show: false } },
        yaxis: { lines: { show: true } },
        padding: { left: 20, right: 20 }
      },
      yaxis: {
        labels: { style: { fontSize: '13px', colors: '#99aabb' } }
      },
      tooltip: {
        theme: 'light',
        style: { fontSize: '13px' }
      },
      xaxis: {
        categories: ['t-6', 't-5', 't-4', 't-3', 't-2', 't-1', 'today']
      },
    },
    bar_series: [{
      name: 'IN',
      data: []
    },{
      name: 'OUT',
      data: []
    }],
    don_options: {
      labels: ['Exp.Vehicle', 'Exp.STNK', 'Exp.KIR',]
    },
    don_series: [0, 0, 0],
    stats: {
      truck: 0,
      permit_open: 0,
      permit_used: 0,
      completed: 0,
    },
    isSubmitting: false,
    password: '',
  }),
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    async loadAuditLog(page = 1) {
      const audit_log = await auditLog(page);
      this.auditLogData.logs = audit_log.data;
    },
    bgGradient(gradient) {
      return {
        background: gradient
      }
    },
    handleResize() {
      this.display = window.innerWidth > 725 ? 580 : 400;
    },
    async download_truck_intensity(){
      // console.log('download_truck_intensity');
      this.isLoadingTruckIntensity = true;
      
      let from = this.date_from+' 00:00:00';
      let to = this.date_to+' 23:59:59';
      
      try {

        await downloadTruckIntensity({from,to});

      } catch (e) {
        this.$bvToast && this.$bvToast.toast('Download gagal!', { variant: 'danger' });

      } finally {
        this.isLoadingTruckIntensity = false;
      }
    },
    async download_exp_lists(){
      return await downloadExpLists();
    },
    async dash_chart(){

      // gate odol
      const gate_odol = await getInOutGateOdolInfo();
      this.gateOdolData = this.normalizeGateOdolData(gate_odol.data);
      
      await this.loadAuditLog();
      
      // today in out
      const today_in_out = await todayInOut();
      this.todayData = JSON.parse(today_in_out).data

      // member data
      if( this.loggedInUser.role == 'memberadmin' || this.loggedInUser.role == 'member' ){
        // console.log('di dashboard',this.loggedInUser);
        const member_count = await memberCount(this.loggedInUser.member);
        this.memberCount = JSON.parse(member_count).data
      }

      // monthly overview
      const monthly_overview = await monthlyOverview();
      this.barChartData = JSON.parse(monthly_overview).data;

      // daily activity
      try {
        this.lineChartLoading = true;
        const daily_activity = await dailyActivity();
        this.lineChartData = JSON.parse(daily_activity).data;
        // console.log('daily activity',this.lineChartData);
      } finally {
        this.lineChartLoading = false;
      }

      // weekly heatmap
      const weekly_heatmap =  await weeklyHeatmap();
      const heatmap = JSON.parse(weekly_heatmap);
      this.heatMapData.data = heatmap.data;
      this.heatMapData.periods = heatmap.periods;

      // acitivy logs
      const activity_logs = await activityLogs();
      this.activityLogData.logs = JSON.parse(activity_logs).data;

      // expired
      const data_expired = await getExpiredInfo();
      const {rsp} = JSON.parse(data_expired);
      this.don_series = [rsp.vehicle_exp, rsp.stnk_exp, rsp.kir_exp];
      
      // in out
      const in_out = await getInOutInfo();
      const {tapped_in, tapped_out, week_dates} = JSON.parse(in_out);
      this.bar_series[0].data = tapped_in.reverse();
      this.bar_series[1].data = tapped_out.reverse();
      this.bar_options.xaxis.categories = week_dates.reverse();
      this.$apexcharts.exec('vuechart-example', 'updateSeries', [{
        data: tapped_in
      },{
        data: tapped_out
      }])
      this.$apexcharts.exec('vuechart-example', 'updateOptions', {
        xaxis: {
          categories: week_dates
        }
      })
      
      // top 10 frequently trucking
      const freq_truck = await getFrequentlyTrucking();
      this.frequentlyTrucking.trucking = JSON.parse(freq_truck);
      
    },
    normalizeGateOdolData(payload = {}) {
      return {
        in: {
          total: this.toNumber(payload?.in?.total),
          categories: {
            umum: this.toNumber(payload?.in?.categories?.umum),
            container: this.toNumber(payload?.in?.categories?.container),
            looseCargo: this.toNumber(payload?.in?.categories?.looseCargo),
          },
        },
        out: {
          total: this.toNumber(payload?.out?.total),
          categories: {
            umum: this.toNumber(payload?.out?.categories?.umum),
            container: this.toNumber(payload?.out?.categories?.container),
            looseCargo: this.toNumber(payload?.out?.categories?.looseCargo),
          },
        },
        top10: {
          in: this.normalizeTop10Rows(this.resolveTop10List(payload, 'in')),
          out: this.normalizeTop10Rows(this.resolveTop10List(payload, 'out')),
        },
      };
    },
    resolveTop10List(payload = {}, direction = 'in') {
      const candidates = [
        payload?.top10?.[direction],
        payload?.[`top10${direction.toUpperCase()}`],
        payload?.[`top_10_${direction}`],
        payload?.[`top_${direction}`],
        payload?.[`${direction}_top_10`],
        payload?.[direction]?.top10,
        payload?.[direction]?.top,
        payload?.[direction]?.vehicles,
      ];

      const list = candidates.find((item) => Array.isArray(item));
      return Array.isArray(list) ? list : [];
    },
    normalizeTop10Rows(rows = []) {
      return rows
        .map((item, index) => {
          if (typeof item === 'string') {
            return {
              no_pol: item,
              total: 0,
            };
          }

          if (!item || typeof item !== 'object') {
            return null;
          }

          const no_pol =
            item.no_pol ||
            item.lic_plate ||
            item.license_plate ||
            item.number_plate ||
            item.plate ||
            `Kendaraan ${index + 1}`;

          const total =
            item.total ||
            item.count ||
            item.intensity ||
            item.frequency ||
            item.trip ||
            item.value ||
            0;

          return {
            no_pol,
            total: this.toNumber(total),
          };
        })
        .filter((item) => !!item)
        .slice(0, 10);
    },
    toNumber(value) {
      return Number(value) || 0;
    },
    async getStats() {
      let params = {};
      if (!this.isSuperAdmin) {
        params['member'] = this.member.id
      }  

      const { data: { data: { dashboard }}} = await getDashStats(params);
      this.stats = dashboard;
      this.stats.completed = dashboard.permit_used / (dashboard.permit_open + dashboard.permit_used);
      this.stats.completed = Math.round((this.stats.completed + Number.EPSILON) * 100 );
    },
    showPassword({user}){
      this.password = user.paswd;
      this.$bvModal.show('credential')
    },
    async onPeriodSelected(period) {
      // handle period selected from DashboardTabs (value in hours: 6, 12, 24)
      this.selectedPeriod = period;
      try {
        this.lineChartLoading = true;
        const daily_activity = await dailyActivity(this.selectedPeriod);
        this.lineChartData = JSON.parse(daily_activity).data;
      } finally {
        this.lineChartLoading = false;
      }

      // console.log('period selected from DashboardTabs:', period);
      // console.log('this.selectedPeriod', this.selectedPeriod);
    },
    async onChangeHeatmapMark(mark){
      if(mark < 0){
        return;
      }

      try{
        this.lineChartLoading = true;
        const weekly_heatmap =  await weeklyHeatmap(mark);
        const heatmap = JSON.parse(weekly_heatmap);
        this.heatMapData.data = heatmap.data;
        this.heatMapData.periods = heatmap.periods;
        // console.log('mark changed from DashboardTabs:', mark);
      }finally{
        this.lineChartLoading = false;
      }
    }
  },
  mounted() {
    this.dash_chart();
    this.getStats();
  },
}
</script>

<style scoped>

</style>
